var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "设备ID冲突提示",
        visible: _vm.innerVisible,
        width: "760px",
        "append-to-body": "",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
      },
    },
    [
      _vm.list.length
        ? _c(
            "div",
            { staticClass: "conflict-section" },
            [
              _c("div", { staticClass: "conflict-title" }, [
                _vm._v(_vm._s(_vm.displayConfig.title)),
              ]),
              _vm.displayConfig.content.length
                ? _c(
                    "div",
                    { staticClass: "conflict-tips" },
                    _vm._l(_vm.displayConfig.content, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "conflict-tip-item" },
                        [
                          _c("span", [_vm._v(_vm._s(index + 1) + ". ")]),
                          _c("span", [_vm._v(_vm._s(item))]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.list,
                    "max-height": "300",
                    size: "mini",
                    border: "",
                    "header-cell-style": { background: "#F5F6F7" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "设备ID",
                      prop: "deviceId",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.deviceId || "-") +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      275017157
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备UUID",
                      prop: "deviceUuid",
                      "min-width": "160",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.deviceUuid || "-") +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1767358053
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备名称",
                      prop: "deviceName",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.deviceName || "-") +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2146317135
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "家庭名称",
                      prop: "spaceName",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.spaceName || "-") +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3662927123
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c("el-empty", { attrs: { description: "暂无冲突设备" } }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "14" }, on: { click: _vm.handleClose } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "14" },
              on: { click: _vm.submitForm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }